import { LINKS } from "@/lib/site";

export const Footer = () => {
  return (
    <footer className="bg-ink text-paper border-t border-ink" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 border-b border-white/15 pb-10">
          <div>
            <p className="font-mono text-base uppercase tracking-[0.14em] text-flame text-pretty">Ready when you are</p>
            <p className="mt-3 font-display font-semibold tracking-[-0.03em] text-3xl md:text-5xl leading-[0.95] text-paper max-w-xl text-pretty">
              Hit the number.{" "}
              <span className="font-editorial italic font-medium text-cobalt">Start this week.</span>
            </p>
          </div>
          <a
            href={LINKS.cal}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-fit items-center bg-cobalt px-7 py-4 font-mono text-base font-medium uppercase tracking-[0.12em] text-white border border-white/20 transition-all duration-200 hover:-translate-y-1 hover:shadow-hard"
            data-testid="footer-book"
          >
            Book a meeting
          </a>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <a href="#top" className="flex items-center">
            <img src="/logo-white.png" alt="GTM Consultancy" className="h-9 w-auto" />
          </a>
          <div className="flex flex-wrap gap-8 font-mono text-base uppercase tracking-[0.1em]">
            <a href={LINKS.playbook} target="_blank" rel="noopener noreferrer" className="text-paper hover:text-flame transition-colors" data-testid="footer-playbook">
              $1M Playbook
            </a>
            <a href={LINKS.linkedin} target="_blank" rel="noopener noreferrer" className="text-paper hover:text-flame transition-colors" data-testid="footer-linkedin">
              LinkedIn
            </a>
            <a href="#pricing" className="text-paper hover:text-flame transition-colors">
              Pricing
            </a>
          </div>
          <span className="font-mono text-base uppercase tracking-[0.1em] text-paper">
            GTM Consultancy © {new Date().getFullYear()}
          </span>
        </div>
      </div>
    </footer>
  );
};
